<div class="flex flex-row flex-wrap items-center justify-start" *ngIf="breadcrumbs$ | ngrxPush as breadcrumbs">
    <div *ngFor="let breadcrumb of getPrevious(breadcrumbs)" class="flex flex-row flex-nowrap items-center justify-start space-x-2 mr-2">
        <div class="text-md cursor-pointer text-base-content" (click)="activate(breadcrumb)">
            {{ breadcrumb.text | truncate: [30] }}
        </div>
        <iota-icon icon="chevron-right" class="stroke-[3]"> </iota-icon>
    </div>
    <div class="text-md text-base-content" [innerHtml]="getCurrent(breadcrumbs)?.text || '' | truncate: [30]"></div>
</div>
